// Mobilní sbalení stromu kategorií v sidebaru (.box-categories).
// Sidebar se na mobilu (max-xl) stackuje NAD obsah a strom má ~600 px — sbalujeme
// ho na tlačítko z nativního headingu (h3.pageElement__heading). Kategorie zůstávají
// první blok sidebaru (rozhodnutí 2026-07-10; pořadí řeší CSS order v _subpage.scss).
// Desktop: strom vždy viditelný, heading zůstává nadpis (atributy jen pod mq).
// Idempotentní (re-init po AJAX).

const MQ = '(max-width: 1024px)'; // = t.mq-max(xl)

export function initSidebarCatsToggle() {
  const box = document.querySelector('.sidebar-left .box-categories');
  if (!box || box.dataset.bsCatsToggle) return;
  const heading = box.querySelector('.pageElement__heading');
  if (!heading) return;
  box.dataset.bsCatsToggle = '1';

  const mq = window.matchMedia(MQ);

  const syncA11y = () => {
    if (mq.matches) {
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.setAttribute('aria-expanded', box.classList.contains('bs-cats-open') ? 'true' : 'false');
    } else {
      heading.removeAttribute('role');
      heading.removeAttribute('tabindex');
      heading.removeAttribute('aria-expanded');
      box.classList.remove('bs-cats-open');
    }
  };

  const toggle = () => {
    if (!mq.matches) return;
    box.classList.toggle('bs-cats-open');
    heading.setAttribute('aria-expanded', box.classList.contains('bs-cats-open') ? 'true' : 'false');
  };

  heading.addEventListener('click', toggle);
  heading.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  });
  // Safari < 14 zná jen `addListener` (code review B5-01, vzor footerAccordion.js)
  if (mq.addEventListener) mq.addEventListener('change', syncA11y);
  else if (mq.addListener) mq.addListener(syncA11y);
  syncA11y();
}
